(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("dM4ny", function(module, exports) {
    $parcel$export(module.exports, "addToCart", function() {
      return $a07327994fef2925$export$576b6dd9d68b37bc;
    });
    $parcel$export(module.exports, "changeCartItem", function() {
      return $a07327994fef2925$export$ededa44e5413fe65;
    });
    function $a07327994fef2925$var$resolve() {
      if (!window.MBF?.cart) console.warn("[cart] window.MBF.cart is not initialised yet");
      const c = window.MBF?.cart;
      if (!c) throw new Error("[cart] not initialised");
      return c;
    }
    const $a07327994fef2925$export$576b6dd9d68b37bc = (input, opts) => $a07327994fef2925$var$resolve().add(input, opts);
    const $a07327994fef2925$export$ededa44e5413fe65 = (data, opts) => $a07327994fef2925$var$resolve().change(data, opts);
    const $a07327994fef2925$export$edba26a5417c3f39 = (data, opts) => $a07327994fef2925$var$resolve().update(data, opts);
    const $a07327994fef2925$export$3c1cc9429c2b6cf3 = opts => $a07327994fef2925$var$resolve().get(opts);
    const $a07327994fef2925$export$1688fd4de852c854 = () => $a07327994fef2925$var$resolve().get().then(c => c.item_count);
  });
  var $dM4ny = parcelRequire("dM4ny");
  class $fffc8df2411ed9cb$var$CartItem extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.save = this.querySelector("[data-save]");
      this.close = this.querySelector("[data-close]");
      this.remove = this.querySelector("[data-remove-gift-wrap]");
      this.radioLabels = this.querySelectorAll("[data-radio-label]");
      this.to = this.querySelector("[data-to]");
      this.message = this.querySelector("[data-message]");
      this.id = this.querySelector("[data-variant-id]").value;
      this.giftWrapId = this.querySelector("[data-gift-wrap-id]")?.value;
      this.key = this.querySelector("input[data-gift-wrap-key]")?.value;
      this.quantity = this.querySelector("[data-quantity]").value;
      this.addBtn = this.querySelector("[data-add-gift-wrap]");
      this.setupEventListeners();
    }
    setupEventListeners() {
      if (this.remove) this.remove.addEventListener("click", this.removeGiftWrap.bind(this));
      this.save?.addEventListener("click", event => this.onClickHandler(event));
      this.close?.addEventListener("click", event => this.closeHandler(event));
      this.radioLabels.forEach(label => {
        label.addEventListener("click", event => this.onRadioLabelClick(event));
      });
      if (this.addBtn) this.addBtn.addEventListener("click", this.addGiftWrapImmediately.bind(this));
    }
    closeHandler(event) {
      event.preventDefault();
      this.querySelector("[data-hide]").click();
    }
    addGiftWrapImmediately(event) {
      event.preventDefault();
      const firstProduct = this.querySelector("[data-product]");
      if (firstProduct) {
        this.product = firstProduct.value;
        this.addGiftWrap();
      }
    }
    onClickHandler(event) {
      event.preventDefault();
      this.product = this.querySelector("[data-product]:checked")?.value || null;
      if (this.giftWrapId && this.product && this.product !== this.giftWrapId) this.changeGiftWrap(); else if (this.product) this.addGiftWrap(); else this.removeGiftWrap();
    }
    onRadioLabelClick(event) {
      const element = event.target;
      const inputId = element.dataset.for;
      const radioInput = document.getElementById(inputId);
      const remove = element.hasAttribute("data-remove-label");
      if (!radioInput) return;
      radioInput.checked = !(radioInput.checked && remove);
    }
    getGiftMessageProperties() {
      const to = this.to?.value;
      const message = this.message?.value;
      return {
        ...to && {
          to: to
        },
        ...message && {
          message: message
        },
        _gift_wrapped: "true"
      };
    }
    addGiftWrap() {
      const properties = this.getGiftMessageProperties();
      (0, $dM4ny.changeCartItem)({
        id: this.key,
        quantity: this.quantity,
        properties: properties
      }).then(() => {
        this.addGiftWrapProduct();
      });
    }
    addGiftWrapProduct() {
      const cartComponent = this.closest("shopping-cart");
      this.toggleCartLoading(true);
      (0, $dM4ny.addToCart)({
        items: [ {
          id: this.product,
          quantity: 1,
          properties: {
            _hidden: "true",
            _related_product_id: this.id
          }
        } ]
      }).then(() => {
        if (cartComponent) {
          cartComponent._isQuantityUpdate = true;
          cartComponent.updateFacets();
          cartComponent._isQuantityUpdate = false;
        }
      }).finally(() => this.toggleCartLoading(false));
    }
    removeGiftWrap() {
      const cartComponent = this.closest("shopping-cart");
      this.toggleCartLoading(true);
      (0, $dM4ny.changeCartItem)({
        id: this.giftWrapId,
        quantity: 0
      }).then(() => (0, $dM4ny.changeCartItem)({
        id: this.key,
        quantity: this.quantity,
        properties: {
          _gift_wrapped: "false"
        }
      })).then(() => {
        if (cartComponent) {
          cartComponent._isQuantityUpdate = true;
          cartComponent.updateFacets();
          cartComponent._isQuantityUpdate = false;
        }
      }).finally(() => this.toggleCartLoading(false));
    }
    changeGiftWrap() {
      const properties = this.getGiftMessageProperties();
      (0, $dM4ny.changeCartItem)({
        id: this.giftWrapId,
        quantity: 0
      }).then(() => this.cart.add({
        items: [ {
          id: this.product,
          quantity: this.quantity,
          properties: {
            _hidden: "true",
            _related_product_id: this.id
          }
        } ]
      })).then(() => {
        this.updateProductProperties(properties);
      });
    }
    toggleCartLoading(isLoading) {
      const cartComponent = this.closest("shopping-cart");
      if (!cartComponent) return;
      if (isLoading) {
        cartComponent.setAttribute("data-loading", "true");
        document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "cart-item"
          }
        }));
      } else {
        cartComponent.removeAttribute("data-loading");
        document.dispatchEvent(new CustomEvent("spinner:hide", {
          detail: {
            source: "cart-item"
          }
        }));
      }
    }
    updateProductProperties(properties) {
      (0, $dM4ny.changeCartItem)({
        id: this.key,
        quantity: this.quantity,
        properties: properties
      });
    }
  }
  if (!customElements.get("cart-item")) customElements.define("cart-item", $fffc8df2411ed9cb$var$CartItem);
})();